module.exports = __webpack_public_path__ + "static/img/Andrew_Gaff_desktop.aac24f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew_Gaff_desktop.jpg
// module id = PIBj
// module chunks = 0